import { produce } from "immer";
import React, { useMemo } from "react";

import { useQueryGetBankLabels } from "@examspark/common-app";
import { Text } from "@examspark/common-ui";
import { useDebounce } from "@examspark/common-ui/dist/hooks/useDebounce";

import { Filter, FilterData } from "../Browse";
import {
  getTermAggregationBuckets,
  useSearch,
  useSearchFn,
} from "../useSearch";

import FilterCheckboxList from "./FilterCheckboxList";

const FilterBank = (props: {
  onChange: (values: string[]) => void;
  filters: FilterData;
  useSearchFn?: useSearchFn;
}) => {
  const filter = useMemo(() => {
    const { bankId, ...filter } = props.filters;
    return filter;
  }, [props.filters]);

  const searchFn = props.useSearchFn ?? useSearch;

  const debouncedFilter = useDebounce(filter, 500);

  const { data } = searchFn({
    queryKey: ["aggs", "bankId", debouncedFilter],
    searchLabel: "SearchAggsBank",
    limit: 0,
    filter: debouncedFilter,
  });

  const buckets = getTermAggregationBuckets(data?.aggregations ?? {}, "bankId");

  const bankLabels = useQueryGetBankLabels(buckets.map((b) => b.key));

  if (buckets.length === 0) return null;

  return (
    <Filter>
      <Text.H2>Content</Text.H2>
      <FilterCheckboxList>
        {buckets?.map((bucket, index) => (
          <FilterCheckboxList.Item
            key={bucket.key}
            checked={props.filters.bankId?.includes(bucket.key)}
            count={bucket.doc_count}
            onClick={() => {
              props.onChange(
                produce(props.filters.bankId ?? [], (draft) => {
                  const index = draft.indexOf(bucket.key);
                  if (index >= 0) {
                    draft.splice(index, 1);
                  } else {
                    draft.push(bucket.key);
                  }
                }),
              );
            }}
          >
            {bankLabels.data?.[index]}
          </FilterCheckboxList.Item>
        ))}
      </FilterCheckboxList>
    </Filter>
  );
};

export default FilterBank;
